export default __webpack_public_path__ + "static/media/ppi-vertical-blue.037190cf.svg";